import React from 'react';
import PropTypes from 'prop-types';
import { getIndexPageItems } from 'SharedPartials/getIndexPageItems';
import { getLoadMore } from 'SharedPartials/getLoadMore';
import {
  getAuthorBio,
  getBreadcrumbs,
} from 'SharedPartialsLocal';

// Template styles and imports
import 'Styles/components/templates/_Author.scss';

const Author = ({
  layoutData: { page: { breadcrumbs, author } },
  pagination: {
    isLoading,
    loadMore,
    setPageRef,
    pages,
    hasMore,
  },
  config: {
    adBreakPoints,
    globalSettings: {
      promoBoxSettings,
    },
  },
}) => {
  const config = {
    promoBoxConfig: {
      ...promoBoxSettings,
      extraClassNames: {
        '-index': true,
      },
      imageSize: 'subscription',
      ppc: promoBoxSettings.subscriptionIndex,
    },
    adBreakPoints,
  };

  const loadMoreParams = {
    label: isLoading ? 'Loading...' : 'Load More',
    loadMore,
    isLoading,
    extraClassNames: {
      'polaris__load-more--small': true,
    },
  };

  return (
    <div className="polaris__body">
      <main className="polaris__main -author-template" id="main">
        <div className="polaris__core-content polaris__content">
          {getBreadcrumbs(breadcrumbs, false, false, 'Author')}
        </div>

        <div className="polaris__author-bio-wrapper">
          <div className="polaris__content polaris__core-content">
            <div className="polaris__content--grey-bottom" />
            {getAuthorBio(author)}
          </div>
        </div>


        <div className="polaris__core-content polaris__content">
          <div data-previous="1" ref={setPageRef} />
          {getIndexPageItems({
            articlesPerRow: 3,
            articleCardProps: {
              datePosition: 'bottom',
              showRating: true,
            },
            config,
            newsletterPosition: false,
            nativeAdPosition: 5,
            pages,
            promoboxPosition: 5,
            setPageRef,
            templateType: 'indexTemplate',
          })}
          {hasMore && getLoadMore(loadMoreParams)}
        </div>
      </main>
    </div>
  );
};

Author.propTypes = {
  layoutData: PropTypes.shape({
    page: PropTypes.object.isRequired,
  }).isRequired,
  pagination: PropTypes.shape({
    isLoading: PropTypes.bool,
    loadMore: PropTypes.func,
    pages: PropTypes.object,
    setPageRef: PropTypes.func,
    hasMore: PropTypes.bool,
  }).isRequired,
  config: PropTypes.shape().isRequired,
};

export { Author };
